export const PREFILL_HAS_NO_MATCH = 'PREFILL_HAS_NO_MATCH';

export const prefillHasNoMatch = payload => dispatch =>
  dispatch({
    type: PREFILL_HAS_NO_MATCH,
    payload,
  });
